import { File } from '../../profile/model/user.model';

export class UserId {
    constructor(
      public firstname: string = "",
      public lastname: string = "",
      public email: string = "",
      public phoneNumber: string = "",
      public enabled: boolean = true,
      public admin: boolean = false, 
      public id: string = "",
      public userFile?: File,
      public emailNotifiable: boolean = false,
      public whatsappNotifiable: boolean = false,
      public roles: string[] = [],
      public deleted: boolean = false,
    ) {}
  }

  export class User {
    constructor(
      public firstname: string = "",
      public lastname: string = "",
      public email: string = "",
      public admin: boolean = false, 
      public id: string = "", 
    ) {}
  }
  export class InvitedUser {
    constructor(
      public firstname: string = "",
      public lastname: string = "",
      public email: string = "",
      public active: boolean = true,
      public id: string = "", 
    ) {}
  }
